import { render, staticRenderFns } from "./CMAttachmentsCreateRefund.vue?vue&type=template&id=0bdd24a7&scoped=true&"
import script from "./CMAttachmentsCreateRefund.vue?vue&type=script&lang=js&"
export * from "./CMAttachmentsCreateRefund.vue?vue&type=script&lang=js&"
import style0 from "./CMAttachmentsCreateRefund.vue?vue&type=style&index=0&id=0bdd24a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdd24a7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bdd24a7')) {
      api.createRecord('0bdd24a7', component.options)
    } else {
      api.reload('0bdd24a7', component.options)
    }
    module.hot.accept("./CMAttachmentsCreateRefund.vue?vue&type=template&id=0bdd24a7&scoped=true&", function () {
      api.rerender('0bdd24a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/attachments/CMAttachmentsCreateRefund.vue"
export default component.exports